import { Fragment, ReactNode, useState, useContext } from "react"
import { AlertMessage } from "source/shared/components"
import {
  FindVerifiedPerson,
  communicateErrorAsHelpfulAsPossible,
} from "source/login/FindVerifiedPerson"
import { sessionApiClient } from "@planningcenter/cc-api-client"
// @ts-expect-error - No types available for this module
import { resetCache as resetNavitarCache } from "@planningcenter/cc-nav"
import { resetCache as resetWebBootCache } from "source/publishing/WebBoot"
import { DynamicSessionContext } from "source/shared/contexts/DynamicSession"
import { LoginFormBaseProps } from "./types"

interface Person {
  data: {
    attributes: {
      token: string
    }
  }
}

interface LoginFormProps extends LoginFormBaseProps {}
export function LoginForm({
  emailOnly,
  textOverrides,
  onSuccess,
}: LoginFormProps) {
  const [error, setError] = useState<false | ReactNode>(false)
  const [key, setKey] = useState(0)
  const context = useContext(DynamicSessionContext)

  async function loginAndRedirect(person: Person): Promise<void> {
    try {
      await sessionApiClient.login(person.data.attributes.token)
      resetNavitarCache()
      resetWebBootCache()
      if (onSuccess) {
        await context?.refreshSession()
        onSuccess()
      } else {
        window.location.reload()
      }
    } catch (err) {
      setError(communicateErrorAsHelpfulAsPossible(err as Error))
    }
  }

  function restart() {
    setError(false)
    setKey((prev) => prev + 1)
  }

  const params = new URLSearchParams(window.location.search)
  const defaultValue = params.get("value") || ""
  const autoSubmitDefaultValue = false // params.has("autosubmit") // NOTE: Disabled temporarily. See Pull Request #287 for details.

  return error ? (
    <Fragment>
      <AlertMessage>{error}</AlertMessage>
      <div className="ta-c">
        <button className="secondary-btn btn mb-3 mt-3" onClick={restart}>
          Start over
        </button>
      </div>
    </Fragment>
  ) : (
    <FindVerifiedPerson
      key={`FindVerifiedPerson-${key}`}
      onChange={loginAndRedirect}
      defaultValue={defaultValue}
      autoSubmitDefaultValue={key === 0 && autoSubmitDefaultValue}
      emailOnly={emailOnly}
      textOverrides={textOverrides}
    />
  )
}
